import React from "react";
import { withRouter } from "react-router-dom";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { map, filter, get, size, uniqBy } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Popper from "@material-ui/core/Popper";

import SubMenuElement from "./SubMenuElement";
import SubMenuElementWithSubMenu from "./SubMenuElementWithSubMenu";

import colors from "../../assets/style/colors";
import { isAllowed } from "../../utils/users";
const styles = {
  menuItem: {
    height: "54px",
    margin: "20px 0px",
    padding: "5px 0px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  menuItemActive: {
    backgroundColor: colors.lightGreenBg,
  },
  itemHover: {
    backgroundColor: colors.lightGreenBg,
  },
  subMenu: {
    minWidth: "350px",
    backgroundColor: colors.white,
    borderRadius: "4px",
    padding: 0,
    zIndex: 9999,
    boxShadow: `0px 2px 4px 0px ${colors.black54}`,
  },
  subMenuTitle: {
    height: "30px",
    lineHeight: "30px",
    padding: "0px 10px",
    backgroundColor: colors.greyDoughnut,
    color: colors.black54,
    textTransform: "uppercase",
    fontSize: "0.875em",
  },
  subMenuCategory: {
    color: colors.black38,
    padding: "0px 20px",
  },
  subMenuCategoryLine: {
    borderTop: `1px solid ${colors.veryLighPink}`,
    borderBottom: "none",
    borderLeft: "none",
  },
  subMenuItem: {
    cursor: "pointer",
    height: "40px",
    lineHeight: "40px",
    padding: "0px 20px",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
      //color: colors.primary,
    },
  },
};

const MenuElementWithSubMenu = (props) => {
  const { history, item, classes, active, solutionsAccess, userLevel, permissions } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mouseOverButton, setMouseOverButton] = React.useState(false);
  const [mouseOverMenu, setMouseOverMenu] = React.useState(false);

  const id = props.id;

  const handleClose = () => {
    setMouseOverButton(false);
    setMouseOverMenu(false);
  };
  const enterButton = (event) => {
    setAnchorEl(event.currentTarget);
    setMouseOverButton(true);
  };

  const leaveButton = () => {
    // Set a timeout so that the menu doesn't close before the user has time to
    // move their mouse over it
    setTimeout(() => {
      setMouseOverButton(false);
    }, 100);
  };

  const enterMenu = () => {
    setMouseOverMenu(true);
  };

  const leaveMenu = () => {
    setMouseOverMenu(false);
  };

  const handleClick = (url) => {
    history.push(url);
    handleClose();
  };

  let open = mouseOverButton || mouseOverMenu;

  if (
    size(
      filter(
        item.subPages,
        (subPage) =>
          !get(subPage, ["restrict"]) ||
          get(solutionsAccess, [subPage.restrict, "allow"])
      )
    ) === 0
  ) {
    return null;
  }

  const categories = uniqBy(
    map(get(item, ["subPages"]), (subPage) => get(subPage, ["category"]))
  );

  return (
    <MenuItem
      className={clsx(classes.menuItem, {
        [classes.menuItemActive]: active,
        [classes.itemHover]: open,
      })}
      onMouseEnter={enterButton}
      onTouchStart={enterButton}
      onMouseLeave={leaveButton}
      //onTouchEnd={leaveButton}
    >
      <img
        src={
          active || mouseOverButton || mouseOverMenu
            ? item.icons.green
            : item.icons.black
        }
        alt={`${item.name}_logo`}
      />
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        transition
        placement="right-start"
        onClose={handleClose}
        style={{ zIndex: 9999 }}
      >
        <Grid
          container
          direction="column"
          wrap="nowrap"
          className={classes.subMenu}
          onMouseEnter={enterMenu}
          onMouseLeave={leaveMenu}
        >
          <Grid item className={classes.subMenuTitle}>
            {I18n.get(`sidebar_${item.name}`)}
          </Grid>
          {map(
            filter(
              categories,
              (cat) =>
                size(
                  filter(
                    get(item, ["subPages"]),
                    (subPage) =>
                      get(subPage, ["category"]) === cat &&
                      userLevel <= get(subPage, ["enabled"]) &&
                      (!get(subPage, ["restrict"]) ||
                        get(solutionsAccess, [
                          get(subPage, ["restrict"]),
                          "allow",
                        ])) && 
                        (!get(subPage, ["permission"]) ||
                        isAllowed(permissions, get(subPage, ["permission"])))
                  )
                ) > 0
            ),
            (cat, index) => (
              <React.Fragment key={index}>
                {cat !== undefined && (
                  <Grid item style={{ marginTop: "10px", padding: "0px 20px" }}>
                    <Grid container justify="center">
                      <Grid item xs>
                        <hr className={classes.subMenuCategoryLine} />
                      </Grid>
                      <Grid item className={classes.subMenuCategory}>
                        {I18n.get(`sidebar_${cat}`)}
                      </Grid>
                      <Grid item xs>
                        <hr className={classes.subMenuCategoryLine} />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {map(
                  filter(
                    get(item, ["subPages"]),
                    (subPage) =>
                      get(subPage, ["category"]) === cat &&
                      userLevel <= get(subPage, ["enabled"]) &&
                      (!get(subPage, ["restrict"]) ||
                        get(solutionsAccess, [
                          get(subPage, ["restrict"]),
                          "allow",
                        ])) &&
                        (!get(subPage, ["permission"]) ||
                        isAllowed(permissions, get(subPage, ["permission"])))
                  ),
                  (subPage, i) => (
                    <React.Fragment key={i}>
                      {get(subPage, ["subMenu"]) ? (
                        <SubMenuElementWithSubMenu
                          item={subPage}
                          active={false}
                          solutionsAccess={solutionsAccess}
                          userLevel={userLevel}
                          closeParent={handleClose}
                          id={subPage.name}
                          permissions={permissions}
                        />
                      ) : (
                        <SubMenuElement
                          key={i}
                          subPage={{
                            ...subPage,
                            url: subPage.url || `/${item.name}/${subPage.name}`,
                          }}
                          handleClick={handleClick}
                          closeParent={handleClose}
                        />
                      )}
                    </React.Fragment>
                  )
                )}
              </React.Fragment>
            )
          )}
        </Grid>
      </Popper>
    </MenuItem>
  );
};

export default withRouter(withStyles(styles)(MenuElementWithSubMenu));
